import styles from './financialHoardItems.module.css'
import { useMemo } from 'react'
import { FormSeparator } from '../../../../../features/ui'
import { OperationItemsTable } from '../../../../operations'
import { DeliveryOrder } from '../../../../deliveries'
import { HoardOrder } from '../../../state/types'
import { hoardHelpers } from '../../../hooks/hoardHooks'

type Props = {
    hoard: HoardOrder
    deliveryOrders: DeliveryOrder[]
}

// Delivered, pending and returned items of a financial hoard (delivered - returned + pending = used credit)
export const FinancialHoardItems = (props: Props) => {
    const { hoard, deliveryOrders } = props

    const { delivered, pending, returned } = useMemo(
        () => hoardHelpers.getFinancialHoardItemsByStatus(hoard, deliveryOrders),
        [hoard, deliveryOrders]
    )

    const sections = [
        { id: 'delivered-items', title: 'Materiales Entregados', items: delivered },
        { id: 'pending-items', title: 'Pendientes de Entrega', items: pending },
        { id: 'returned-items', title: 'Materiales Devueltos', items: returned }
    ].filter(section => section.items.length > 0)

    return (
        <div className={styles.container}>
            {sections.map(section => (
                <div key={section.id}>
                    <FormSeparator title={section.title} className={styles.title} />
                    <OperationItemsTable
                        itemsData={section.items}
                        createMode={false}
                        readOnly
                    />
                </div>
            ))}
        </div>
    )
}
